import React from 'react';
import { AuthStore } from '@splunk/olly-services/lib/services/Auth/AuthStore';
import { EntityApolloContextProvider } from './EntityApolloContextProvider';
import EntityHealthContent from './EntityHealthContent';
import { API_URL } from '../../../common/consts';
import { react2angular } from 'react2angular';

interface EntityHealthContentWrapperProps {
    entityType?: string;
    isNewDetector: boolean;
    onChange: (entityType: string | undefined) => void;
    dimensionsMap?: Map<string, Set<string>>;
}

const EntityHealthContentWrapper: React.FC<EntityHealthContentWrapperProps> = ({
    entityType,
    isNewDetector,
    onChange,
    dimensionsMap,
}) => {
    const auth = AuthStore(true, API_URL);

    return (
        <EntityApolloContextProvider auth={auth}>
            <EntityHealthContent
                entityType={entityType}
                isNewDetector={isNewDetector}
                onChange={onChange}
                dimensionsMap={dimensionsMap}
            />
        </EntityApolloContextProvider>
    );
};

export const entityHealthContent = react2angular(EntityHealthContentWrapper, [
    'entityType',
    'isNewDetector',
    'onChange',
    'dimensionsMap',
]);
